var MyPosts = React.createClass({
  componentDidMount() {
    this.statusItems = [
      {label: Labels.getLabel("All"), value: ""},
      {label: Labels.getLabel("Answered"), value: 1},
      {label: Labels.getLabel("Unanswered"), value: 0}
    ];

    this.sortKeys = [
      { key: "last_modified_date", label: Labels.getLabel("Newest on Top") },
      { key: "last_modified_date", descending: false, label: Labels.getLabel("Oldest on Top") }
    ];

    let query = {
      userID: this.props.userID,
      sortBy: "last_modified_date",
      hitcount: 5
    };

    RA.CommunitySearch.search(query, this.searchComplete);
  },
  getInitialState() {
    return {
      searchResults: {},
      loading: true,
      selectedSortIndex: 0,
      selectedStatusValue: ""
    }
  },
  searchComplete(searchResults) {
    if (!this.isMounted()) return;

    this.setState({searchResults: searchResults,
      loading: false});
  },
  statusChanged(e) {
    let value = e.currentTarget.value
    this.setState({selectedStatusValue: value,
      loading: true});

    RA.CommunitySearch.applyFilter({answered: value}, this.searchComplete);
  },
  sortChanged(e) {
    let index = e.currentTarget.value;
    let sortKey = this.sortKeys[index];

    this.setState({selectedSortIndex: index,
      loading: true});

    let descending = sortKey.descending == undefined ? "" : sortKey.descending;

    RA.CommunitySearch.applyFilter({sortBy: sortKey.key, descending: descending},
          this.searchComplete);
  },
  pageClicked(num) {
    this.setState({loading: true});

    //window.scrollTo(0, $(this.refs.rootElement).offset().top);

    RA.CommunitySearch.loadPage(num, this.searchComplete);
  },
  renderNoContent() {
    let message = this.state.selectedStatusValue == "" ?
      "You haven't posted any questions yet" :
      "No matching questions found" ;

    return <NoContent message={Labels.getLabel(message)} />
  },
  renderFilters() {
    return (
      <MyPosts.Filters
        sortKeys={this.sortKeys}
        statusItems={this.statusItems}
        selectedSortIndex={this.state.selectedSortIndex}
        selectedStatusValue={this.state.selectedStatusValue}
        onSortChanged={this.sortChanged}
        onStatusChanged={this.statusChanged} />
    )
  },
  render() {
    let {
      searchResults,
      loading,
      selectedStatusValue
    } = this.state;

    if (!searchResults.results) return <div />;

    let {
      pagerDetail,
      totalHits
    } = searchResults;
    let hits = searchResults.results;
    let hasResults = totalHits > 0;
    let isFiltered = selectedStatusValue != "";

    let resultsList = hasResults ?
      <ul className="solution-list">
        {hits.map(hit =>
          <CommResultItem
            key={hit.discussion.id}
            hit={hit}
            size="sm"
            showAuthor={false}
            showReplyCount={false} />)}
      </ul> : null;

    let pager = hasResults && pagerDetail.totalPages > 1 ?
      <BasicPager
        currentPage={pagerDetail.currentPage}
        maxPage={pagerDetail.totalPages}
        onPageClicked={this.pageClicked} /> : null;
    let overlay = loading ? <Overlay /> : null;

    return (
      <div className="my-posts" ref="rootElement">
        <h2 className="section__title">{Labels.getLabel("My Posts")}</h2>

        {hasResults || isFiltered ? this.renderFilters() : null}

        {!hasResults ? this.renderNoContent() : null}

        <div className="my-posts__results">
          {resultsList}
          {pager}
          {overlay}
        </div>
      </div>
    )
  }
});

MyPosts.Filters = React.createClass({
  componentDidMount() {
    try {
      $('#myPostsSort').selectpicker('refresh');
      $('#myPostsStatus').selectpicker('refresh');
    } catch (e) {
      //Do nothing in case bootstrap-select library is not found.
	}
  },
  render() {
    return (
      <form className="form-inline my-posts__filter-row">
        <div className="row">
          <div className="pull-right col-xs-6 col-lg-4">
            <div className="has-float-label">
              <select
                id="myPostsSort"
                className="form-control -sm"
                value={this.props.selectedSortIndex}
                onChange={this.props.onSortChanged}>
                {this.props.sortKeys.map((item, i) =>
                  <option value={i} key={i}>{item.label}</option>)}
              </select>
              <label
                className="control-label my-posts__filter-label"
                htmlFor="myPostsSort">
                  {Labels.getLabel("Sort")}:
              </label>
            </div>
          </div>
          <div className="col-xs-6 col-lg-4">
            <div className="has-float-label">
              <select
                id="myPostsStatus"
                className="form-control -sm"
                value={this.props.selectedStatusValue}
                onChange={this.props.onStatusChanged}>
                {this.props.statusItems.map(item =>
                  <option value={item.value} key={item.value}>{item.label}</option>)}
              </select>
              <label
                className="control-label my-posts__filter-label"
                htmlFor="myPostsStatus">
                  {Labels.getLabel("Status")}:
                </label>
            </div>
          </div>
        </div>
      </form>
    )
  }
})